<template>
  <div v-if="selfShow" class="header-messageCenter" id="box" ref="box">
    <span v-show="newNoticeMessage" class="new-message"></span>
    <span v-show="newSystemMessage" class="new-message"></span>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('messageCenter.noticeMessage')" name="noticeMessage">
        <div class="messageCenter-message-prompt">
          <div
            v-for="(item,index) in noticeMessageList"
            @click="checkDetail(item)"
            :key="index"
            :class="[item.readFlag == 1 ? 'read-message' : '','message-prompt-item']"
          >
            <span class="message-prompt-item-type">{{item.type}}</span>
            <span class="message-prompt-item-content">{{item.notificationContent}}</span>
            <span class="message-prompt-item-time">{{item.createTime}}</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('messageCenter.systemMessage')" name="systemMessage">
        <div class="messageCenter-message-prompt">
          <div
            v-for="(item,index) in systemMessageList"
            @click="checkDetail(item)"
            :key="index"
            :class="[item.readFlag == 1 ? 'read-message' : '','message-prompt-item']"
          >
            <span class="message-prompt-item-type">{{item.type}}</span>
            <span class="message-prompt-item-content">{{item.notificationContent}}</span>
            <span class="message-prompt-item-time">{{item.createTime}}</span>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-button
      type="primary"
      @click="allRead"
      class="messageCenter-button-allRead"
    >{{$t("messageCenter.allRead")}}</el-button>
    <el-button
      type="primary"
      class="header-messageCenter-button"
      @click="lookAll"
    >{{$t("messageCenter.lookAll")}}</el-button>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      activeName: "noticeMessage",
      // noticeMessageList: [],
      // systemMessageList: [],
      // newNoticeMessage: false,
      // newSystemMessage: false,
      userId: sessionStorage.getItem("user_id")
    };
  },
  computed: {
    selfShow: {
      get: function() {
        return this.$store.state.messageCenter.HeaderMessageCenterShow;
      },
      set: function(value) {}
    },
    noticeMessageList: {
      get: function() {
        return this.$store.state.messageCenter.noticeMessageList;
      }
    },
    systemMessageList: {
      get: function() {
        return this.$store.state.messageCenter.systemMessageList;
      }
    },
    newNoticeMessage: {
      get: function() {
        console.log(this.$store.state.messageCenter.newNoticeMessage);
        return this.$store.state.messageCenter.newNoticeMessage;
      },
      set: function(value) {}
    },
    newSystemMessage: {
      get: function() {
        return this.$store.state.messageCenter.newSystemMessage;
      }
    }
  },
  watch: {
    //监听路由
    $route: {
      handler: function(val, oldVal) {
        this.$store.commit("CHANGE_MESSAGE_CENTER_SHOW", false);
      },
      //深度观察监听
      deep: true
    }
  },
  created() {
    document.addEventListener("click", e => {
      var box = document.getElementById("box");
      if (box && box.contains(e.target)) {
        console.log("在内");
      } else {
        this.$store.commit("CHANGE_MESSAGE_CENTER_SHOW", false);
      }
    });
  },
  mounted() {
    let index = window.location.href.indexOf("#");
    let path = window.location.href.slice(
      index + 1,
      window.location.href.length
    );
    if (path !== "/login" && path !== "/") {
      this.getMessageData();
    }
  },
  destroyed() {
    console.log("销毁");
    this.$store.commit("CHANGE_MESSAGE_CENTER_SHOW", false);
  },
  methods: {
    handleClick(tab, event) {
      console.log(this.activeName);
      let params = {
        userId: this.userId,
        pageNo: 1,
        pageSize: 50,
        notificationCategory: this.activeName === "noticeMessage" ? 1 : 0,
        notificationType: null
      };
      this.$store.dispatch("GET_MESSAGE_DATA", {
        that: this,
        params: params
      });
      // this.$store.commit("CHANGE_TAB_NAME", this.activeName);
    },
    lookAll() {
      this.$router.push({ path: "/moduleIndex/messageCenter" });
      this.$store.commit("CHANGE_TAB_NAME", this.activeName);
    },
    // 根据具体消息跳到相应页面
    checkDetail(item) {
      if (item.notificationType == 6 || item.notificationType == 7) {
        this.$post("/course/comment/getComment", {
          id: item.eventId
        })
          .then(res => {
            if (res.code === "00") {
              let params = {
                id: res.data.courseFileId,
                fileName: res.data.courserFileName,
                page: res.data.page
              };
              let menu_str = JSON.parse(sessionStorage.getItem("menuArr"));
              this.$store.commit("CHANGE_TABNAME", 'courseQACenter');
              menu_str.forEach(element => {
                if (element.menuId == 60) {
                  params.source = "headquarters";
                } else if (element.menuId == 61) {
                  params.source = "garden";
                } else if (element.menuId == 62) {
                  params.source = "class";
                } else {
                  params.source = "headquarters";
                }
              });
              this.$router.push({
                path: "/moduleIndex/courseManagement/checkCourseDetails",
                query: params
              });
            }
          })
          .catch(() => {});
      } else {
        this.$router.push({ path: item.routingPath });
      }
      if (item.readFlag == 0) {
        this.$store.commit(
          "CHANGE_MESSAGE_CENTER_SHOW",
          !this.$store.state.messageCenter.HeaderMessageCenterShow
        );
        let params = {
          all: false /*为true的时候使用userId更新全部,false使用id更新单个*/,
          notificationCategory: this.activeName === "noticeMessage" ? 1 : 0,
          userId: this.userId,
          id: item.id,
          path: "header"
        };
        this.$store.dispatch("ALL_READ", {
          that: this,
          params: params
        });
      }
    },
    // 获取消息列表是否有新消息
    getMessageData(params) {
      console.log("是否有新消息");
      this.$store.dispatch("GET_MESSAGE_DATA", {
        that: this,
        params: {
          userId: this.userId,
          pageNo: 1,
          pageSize: 20,
          notificationCategory: null,
          notificationType: null
        }
      });
      this.$store.dispatch("GET_MESSAGE_DATA", {
        that: this,
        params: {
          userId: this.userId,
          pageNo: 1,
          pageSize: 20,
          notificationCategory: 1,
          notificationType: null
        }
      });
    },
    allRead() {
      let params = {
        all: true,
        notificationCategory: this.activeName === "noticeMessage" ? 1 : 0,
        userId: this.userId,
        path: "header"
      };
      this.$store.dispatch("ALL_READ", {
        that: this,
        params: params
      });
    }
  }
};
</script>

<style lang="scss">
.header-messageCenter {
  width: 360px;
  height: 360px;
  position: fixed;
  top: 47px;
  right: 52px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(202, 202, 202, 0.5);
  border-radius: 4px;
  .messageCenter-button-allRead {
    position: absolute;
    right: 0;
    top: 5px;
    border: none;
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 17px;
    background: #fff;
  }
  .new-message {
    display: inline-block;
    border-radius: 50%;
    width: 4px;
    height: 4px;
    background: rgba(255, 50, 50, 1);
    position: absolute;
  }
  .new-message:nth-child(1) {
    left: 77px;
    top: 17px;
  }
  .new-message:nth-child(2) {
    left: 177px;
    top: 17px;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-button--primary:hover {
    background-color: #fff;
    border-color: none;
  }
  .el-button--primary:focus {
    background-color: #fff;
    border-color: none;
  }
  .el-tabs {
    .el-tabs__nav {
      padding-left: 17px;
    }
    .el-tabs__item {
      width: 80px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
    }
    .el-tabs__nav-wrap,
    .el-tabs__header {
      padding: 0 3px;
      height: 48px;
      line-height: 48px;
    }
    .el-tabs__nav .el-tabs__active-bar {
      width: 80px !important;
    }
    .el-tabs__active-bar {
      left: 10px;
    }
  }
  .el-tabs__nav-wrap::after {
    background-color: #dfdfdf;
  }
  .el-button.el-button--primary {
    background: #fff;
    color: rgba(102, 102, 102, 1);
  }
  .messageCenter-message-prompt {
    height: 300px;
    overflow-y: auto;
    .message-prompt-item {
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 17px;
      padding: 20px 12px 0 20px;
      box-sizing: border-box;
      display: flex;
      cursor: pointer;
      .message-prompt-item-type {
        width: 68px;
        padding-right: 12px;
        font-size: 12px;
      }
      .message-prompt-item-content {
        flex: 1;
        font-size: 12px;
      }
      .message-prompt-item-time {
        padding-left: 34px;
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
      }
    }
    .read-message {
      color: #999;
    }
  }
  .header-messageCenter-button {
    border: none;
  }
}
.header-messageCenter-button {
  width: 100%;
  height: 45px;
  border: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/headerMessageCenter.vue